<template>
  <div class="custom-task-edit-component">
    <div class="content" v-if="!isLoading">
      <form @submit.prevent="createCustomTask()" class="make-custom-task-wrap">
        <div class="icon-picker-wrapper input-attributes">
          <label>Symbol</label>
          <div class="icon-content-wrap">
            <div v-if="taskDetails.icon" class="image-preview">
              <img :src="taskDetails.icon" />
            </div>
            <div
              v-click-outside="toggleIconPickerURL"
              class="icon-picker-url-selector"
            >
              <div
                class="btn-black mb-0"
                @click.stop="toggleIconPickerURL(true)"
              >
                <span> Bild hinzufügen </span>
              </div>

              <IconPicker
                v-if="isIconPickerOpen"
                :displayIconPickerSections="['icon', 'illustration', 'custom']"
                :element="taskDetails"
                @updateUrl="taskEditorUpdateIconUrl"
                @updateLinkType="taskEditorUpdateIconUrlType"
              />
            </div>
          </div>
        </div>
        <div class="input-attributes">
          <label>Aufgabenname</label>
          <input v-model="taskDetails.taskname" required />
        </div>
        <div class="input-attributes">
          <label>Aufgabenbeschreibung</label>
          <textarea
            class="description-input"
            placeholder="Description"
            v-model="taskDetails.description"
          />
        </div>
        <!-- Code for the future if input type required -->
        <!-- <div>
          <div v-for="item in inputFieldsDetails" :key="item.name">
            {{ item.name }}
            <generalDropdown>
              <template v-slot:iconContainer>
                <span class="btn-more"></span>
              </template>
              <template v-slot:selectFilter>
                <span class="line-clamp">{{ item.type }} </span>
              </template>
              <template v-slot:optionData>
                <b-dropdown-item
                  v-for="type in nameField"
                  :key="type"
                  @click="onTypeChange(type, item.name)"
                >
                  {{ type }}
                </b-dropdown-item>
              </template>
            </generalDropdown>
          </div>
        </div> -->
        <div class="text-center">
          <button type="submit" class="btn-black submit-btn">Einreichen</button>
        </div>
      </form>
    </div>
    <!-- Use this loading, while component is rendering  -->

    <LoadingSpinner loadingCaption="Wird gespeichert..." v-else />
  </div>
</template>

<script>
import IconPicker from './IconPicker.vue';
import LoadingSpinner from './LoadingSpinner.vue';
// import GeneralDropdown from '../core/general-dropdown.vue';
import { mapGetters } from 'vuex';
import {
  formatTablename,
  getCETTimeStampFromDate,
  getApiEndpointVersion,
} from '../../utils/helpers';
import { createDatabaseTable } from '../../services/customdb.service';
import customTaskDatabaseSchema from '../../assets/data-schemas/customTaskDatabaseSchema.json';
import { addTableItem } from '../../services/userTable';
import { askChatGPT } from '../../services/workflow.service';
export default {
  name: 'MakeCustomTaskComponent',
  data() {
    return {
      isLoading: false,
      taskDetails: {
        description: null,
        taskname: null,
        icon: null,
        linkType: null,
      },
      isIconPickerOpen: false,
    };
  },
  props: {
    editCodeDetails: {
      type: Object,
      default: null,
      required: true,
    },
    inputFields: {
      type: Array,
      default: null,
      required: true,
    },
    flowRunnerEndpoint: {
      type: String,
    },
  },
  methods: {
    close() {
      this.$emit('closeEditModal', false);
    },

    toggleIconPickerURL(value = false) {
      this.isIconPickerOpen = value;
    },
    taskEditorUpdateIconUrl(icon) {
      this.taskDetails.icon = icon;
      this.toggleIconPickerURL();
    },
    taskEditorUpdateIconUrlType(type) {
      this.taskDetails.linkType = type;
      this.toggleIconPickerURL();
    },
    async writeMessage(code) {
      const promptMessage = `Give me short description in german about this code 
      IMPORTANT : make sure to give me description with normal natural language and not include code

      code:
      `;
      try {
        const url = this.flowRunnerEndpoint;
        let res;
        if (getApiEndpointVersion(url) >= 6) {
          const formData = new FormData();
          formData.append(
            'props',
            JSON.stringify({
              prompt: promptMessage + code,
              model: 'gpt-4',
            })
          );
          res = await askChatGPT(url, formData);
        } else {
          res = await askChatGPT(url, {
            prompt: promptMessage + code,
          });
        }
        this.taskDetails.description = res.data.message;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        throw new Error(error);
      }
    },
    onTypeChange(selectType, name) {
      this.inputFieldsDetails.map((data) => {
        if (data.name == name) data.type = selectType;
      });
    },
    async createCustomTask() {
      this.isLoading = true;
      let customtaskDatabaseDetails = this.databaseList.find(
        (database) => database.type == 'custom-task'
      );
      if (!customtaskDatabaseDetails)
        customtaskDatabaseDetails = await this.createCustomTaskDatabase();
      this.addCustomTaskItemInDatabase(
        customtaskDatabaseDetails,
        this.taskDetails
      );
    },
    async createCustomTaskDatabase() {
      try {
        const databaseSchema = customTaskDatabaseSchema.map(
          (schema, index) => ({
            ...schema,
            id: getCETTimeStampFromDate() + (index + 1),
          })
        );
        const formData = new FormData();
        formData.append('caption', 'custom-task');
        formData.append('add_only', false);
        formData.append('icon', null);
        formData.append(
          'tablename',
          this.getUsername + '_' + formatTablename('custom-task')
        );
        formData.append('tabletype', 'custom-task');
        formData.append(
          'layout',
          '{"tabs":[{"id":0,"rows":[{"id":0,"cols":[{"id":0}]}]}]}'
        );
        formData.append('database_type', 'DynamoDB');
        formData.append('type', 'custom-task');
        formData.append('schema', JSON.stringify(databaseSchema));

        const createDatabaseResponse = await createDatabaseTable(formData);
        await this.$store.dispatch('fetchUserDataBase');
        return JSON.parse(createDatabaseResponse.data);
      } catch (error) {
        console.log('error :>> ', error);
      }
    },
    async addCustomTaskItemInDatabase(database, taskDetails) {
      const payloadData = taskDetails;
      delete payloadData.linkType;
      const inputString = this.editCodeDetails.code;
      const filterUsedInputs = [];
      this.inputFields.forEach((inputData) => {
        if (inputData.name !== 'codelosSettings') {
          const regexPattern = new RegExp(
            `input\\[(?:"|')${inputData.name}(?:"|')\\]`
          );
          const matches = regexPattern.test(inputString);
          if (matches) {
            filterUsedInputs.push(inputData);
          }
        }
      });
      const regexPatternAuth = new RegExp(
        `input\\[(?:"|')${'authorization'}(?:"|')\\]`
      );
      const isAuthorization = regexPatternAuth.test(inputString);
      if (isAuthorization) {
        filterUsedInputs.push({
          label: 'Authorization',
          name: 'authorization',
          type: 'text',
          value: '',
        });
      }
      const payload = {
        item: {
          ...payloadData,
          code: this.editCodeDetails,
          inputfields: filterUsedInputs,
        },
      };
      try {
        const response = await addTableItem(database.name, payload);
        if (response.status == 200) {
          this.isLoading = false;
          this.$emit('showToaster', 'Ausgeführt !', 'Erfolgreich', 'success');
          this.$emit('triggerCustomTaskItemFetch', response.data.item_id);
          this.$emit('closeEditModal');
        }
      } catch (error) {
        this.isLoading = false;
        this.$emit(
          'showToaster',
          'Bitte beheben Sie den Fehler im Code !',
          'Fehlerhaft !',
          'danger'
        );
      }
    },
  },
  computed: {
    ...mapGetters({
      databaseList: 'getDatabaseList',
      getUsername: 'getUserId',
    }),
    user() {
      return this.$store.state.user;
    },
  },
  mounted() {
    this.inputFieldsDetails = this.inputFields;
    this.writeMessage(this.editCodeDetails.code);
  },
  created() {
    this.isLoading = true;
  },
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        el.eventOnClick = function (event) {
          // Check that the click was outside the el and its children
          if (!(el == event.target || el.contains(event.target))) {
            // call method provided in attribute value
            vnode.context[binding.expression]();
          }
        };

        document.addEventListener('click', el.eventOnClick);
      },
      unbind(el) {
        document.removeEventListener('click', el.eventOnClick);
      },
    },
  },
  components: {
    LoadingSpinner,
    IconPicker,
    // GeneralDropdown,
  },
};
</script>

<style scoped>
.custom-task-edit-component {
  width: 100%;
  height: 100%;
  background: #ffffff;
  position: absolute;
  display: block;
  top: 0;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #9f9f9f;
  z-index: 99;
}
.custom-task-edit-component .content .icon-picker-wrapper {
  display: flex;
}
.custom-task-edit-component .content .icon-picker-wrapper .image-preview img {
  width: 55px;
}
.custom-task-edit-component .content .input-attributes {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.custom-task-edit-component .content .input-attributes label {
  width: 250px;
  display: block;
  text-align: left;
  padding-right: 15px;
  font-size: 14px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.custom-task-edit-component .content .input-attributes input {
  width: calc(100% - 250px);
  border: 1px solid #dee3e9;
  border-radius: 0.375rem;
  padding: 10px 15px;
  cursor: text;
  height: auto;
}
.custom-task-edit-component .content .input-attributes textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 200px;
  width: calc(100% - 250px);
  overflow: scroll;
}

.custom-task-edit-component .content .btn-black {
  cursor: pointer;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.951);
  border: 3px solid rgba(0, 0, 0, 0.916);
  background-color: rgba(0, 0, 0, 0.916);
  border-radius: 0.375em;
  font-weight: 400;
  line-height: 23px;
  padding: 4px 20px;
  font-size: 14px;
  margin-bottom: 25px;
  margin-top: 5px;
  letter-spacing: 0.6px;
  text-transform: capitalize;
}
.custom-task-edit-component .content h1 {
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 12px;
  font-weight: 400;
  line-height: 35px;
}
.custom-task-edit-component .content h1 {
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 12px;
  font-weight: 400;
  line-height: 35px;
}

.make-custom-task-wrap {
  padding: 20px 30px;
}

.make-custom-task-wrap .input-attributes label {
  width: 250px;
  text-align: left;
  padding-right: 15px;
  font-size: 14px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #212529;
}

.make-custom-task-wrap .input-attributes .icon-content-wrap {
  display: flex;
  align-items: center;
  width: calc(100% - 250px);
}
.image-preview {
  background: #ededed;
  border-radius: 6px;
  margin-right: 10px;
  padding: 4px;
  min-height: 50px;
}
.custom-task-edit-component .content .btn-black.submit-btn {
  font-size: 18px;
  padding: 6px 20px;
}
</style>
